<template>
  <div class="">
    <div class="head-title">朋友圈素材</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            上传朋友圈素材，例如图片、视频等，【朋友圈任务】内可选择素材发布到客户朋友圈。上传素材3天后失效，请及时使用。失效后可点击重新上传，会自动上传素材并更新失效时间。
          </p>
          <p>
            图片（image）：10MB，支持JPG,PNG格式，朋友圈类型图片不超过1440 x 1080
          </p>
          <p>
            视频（video） ：10MB，支持MP4格式，朋友圈类型视频时长不超过30秒
          </p>
          <p>
            文件（file） ：10MB
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="header-menu">
        <div class="menu-left">
          <el-upload class="upload-demo" :action="this.axios.defaults.baseURL + '/crm/FriendsTask/uploadimg'"
            :data="upParams" :before-upload="handleBeforeUpload" :on-success="handleSuccess" :on-error="handleError"
            accept=".png,.jpg,.mp4" :show-file-list="false">
            <el-button type="primary" :loading="uploadLoading" :disabled="uploadLoading" icon="el-icon-upload2">
              本地上传
            </el-button>

            <!-- <div slot="tip" class="el-upload__tip">{{ tip }}</div> -->
          </el-upload>
        </div>
        <div class="menu-right">
          <div style="margin-left: 2.4rem">
            <el-select clearable class="menu-select" style="width: 27.0rem" v-model="type" placeholder="请选择类型"
              @change="changeType">
              <el-option v-for="item in typeData" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="container">
        <el-table :data="tableData" border  v-loading="tableLoading" tooltip-effect="dark">
          <el-table-column show-overflow-tooltip label="素材" prop="url" align="center" style="width:20%">
            <template slot-scope="scope">
              <div v-if="scope.row.type == '图片'">
                <el-image style="height: 6.0rem" :src="scope.row.url" :preview-src-list="[scope.row.url]"
                  fit="scale-down"></el-image>
              </div>
              <div v-if="scope.row.type == '视频'">
                <video style="width: 20.0rem; height: 11.2rem" :src="scope.row.url" controls="controls"></video>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="素材类型" prop="type" style="width:20%"></el-table-column>
          <el-table-column label="状态" prop="status_name" style="width:20%">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 0" style="color: #f56c6c">
                {{ scope.row.status_name }}
              </span>
              <span v-else-if="scope.row.status == 1" style="color: #67c23a">
                {{ scope.row.status_name }}
              </span> -->
              <el-tag v-if="scope.row.status == 0" size="mini" type="danger">{{ scope.row.status_name }}</el-tag>
                <el-tag  v-else-if="scope.row.status == 1" size="mini" type="success">{{ scope.row.status_name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="更新时间" style="width:20%">
            <template slot-scope="scope">
              <span style="margin-left: 1.0rem">{{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="170">
            <template slot-scope="scope">
              <el-button type="text" size="mini" :loading="scope.row.loading" :diabled="scope.row.loading"
                @click="handleReplayUpload(scope.row)">重新上传</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
            :page-sizes="[10, 20, 50, 100]" @pagination="getData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";

export default {
  name: "materialAdminCircle",
  components: {
    pagination,
  },
  data() {
    return {
      msgType: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      content: "",
      upParams: {
        type: "图片",
      },
      type: "",
      typeData: [
        {
          value: "",
          label: "请选择类型",
        },
        {
          value: "图片",
          label: "图片",
        },
        {
          value: "视频",
          label: "视频",
        },
      ],
      uploadLoading: false,
      tableLoading: true,
    };
  },
  mounted() {
    this.upParams.account_id = this.tooken.account_id;
    this.getData();
  },
  methods: {
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message({
          message: "上传素材过大",
          type: "error",
        });
        return false;
      }
      switch (file.type) {
        case "image/jpeg":
          this.upParams.type = "图片";
          break;
        case "image/png":
          this.upParams.type = "图片";
          break;
        case "video/mp4":
          this.upParams.type = "视频";
          break;
        default:
          break;
      }
      this.uploadLoading = true;
    },
    handleSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          message: response.msg,
          type: "error",
        });
      } else if (response.code) {
        this.$message({
          message: response.msg,
          type: "success",
        });
        this.getData();
      }
      this.uploadLoading = false;
    },
    handleError(response) {
      this.$message({
        message: response.msg,
        type: "error",
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    getData() {
      this.axios
        .post(
          "/crm/FriendsTask/getMaterial",
          qs.stringify({
            examineCode: this.tooken.examineCode,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            type: this.type,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == 1) {
            res.data.data.data.forEach((item) => {
              item.loading = false;
            });
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    async handleReplayUpload(item) {
      item.loading = true;
      let mediaid = item.media_id;
      const { data: res } = await this.axios({
        url: "/crm/FriendsTask/uploadimg2",
        method: "POST",
        data: this.qs.stringify({
          examineCode: this.tooken.examineCode,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: item.id,
        }),
        timeout: 60000,
      });
      item.loading = true;
      if (res.code == 0) {
        this.$message.error(res.msg);
      } else if (res.code == 1) {
        this.$message.success(res.msg);
      }
      this.getData();
    },
    onUpload() { },
    handleDelete(index, row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CircleMaterial/delMaterial",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: row.id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.tableData = [];
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeType() {
      this.getData();
    },
  },
};
</script>
<style  scoped>
.materialAdmin {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}

.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}

.header-menu {
  margin: 1.0rem 0 2.0rem 0;
  display: flex;
  justify-content: space-between;
}

.menu-right {
  display: inline-flex;
}

.menu-select {
  margin-right: 1.6rem;
}

.paging {
  margin-top: 2.0rem;
}

.header-menu .menu-left .copy-url {
  margin-left: 2.4rem;
}
</style>
